module.exports = __webpack_public_path__ + "components/zebra-list/static/speech-bubbles-8022c88c2f9fdd929bf02691ea5400df.svg";